import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { ScrollView, LoadingView } from '../../../../common/components/atoms';
import { ModalDialog } from '../../../../common/components/molecues';
import { HeaderTop, Subject, HelpDialog } from '../../../components/molecues';

import { getSplitedDivs, convISO8601 } from '../../../../common/helper/commonHelper.js'
import { USERTYPE, SUBJECT_DISPLAY_TYPE, SUBJECT_KBN } from '../../../common/constants.js';
import { DialogMessage } from '../../../common/DialogMessage.jsx';

import { getNextMonth, getPrevMonth } from '../../../../common/helper/commonHelper.js';

class Top extends Component {
    constructor(props) {
        super(props);

        this.loadingSubject = false;
        this.loadingVocabulary = false;
        this.loadingChunk = false;
        this.loadingRecordHistory = false;

        this.refScroll = React.createRef();

        let currentDate;
        let scroll;
        if(props.location.state && props.location.state.referrer){
            currentDate = this.props.toppageDate ? new Date(this.props.toppageDate) : new Date();
            scroll = this.props.toppageScroll ? this.props.toppageScroll : 0;
        } else {
            currentDate = new Date();
            scroll = 0;
        }
        this.state = {
            current: 0,
            displayCommentDlg: false,
            currentDate: currentDate,
            initScroll: scroll,
            subjectList: [],
            commentList: [],
            comment: {title: "", comment: ""},
            selectedSubject: null,
            subjectKbn: localStorage.getItem('SubjectKbn') ? localStorage.getItem('SubjectKbn') : SUBJECT_KBN.DELIVERY,
            subjectDisplayType: localStorage.getItem('SubjectDisplayType') ? localStorage.getItem('SubjectDisplayType') : SUBJECT_DISPLAY_TYPE.ALL,
            helpDisplay: false,
            feedbackContentsDisplay: localStorage.getItem('FeedBackDisplay') ? ((localStorage.getItem('FeedBackDisplay') == "true") ? true : false) : true,
        }
    }

    componentDidMount() {
		this.props.dispatch({
            type: "LoadEnd"
        });
        this.props.dispatch({
            type: "CheckMaintenance_Saga"
        });
        this.reload(false);
    }

    reload = (force) => {
        let today = new Date();
        this.props.dispatch({
            type: "GetSendCount_Saga",
            id: this.props.user.id,
            course: this.props.user.course,
            month: today.getFullYear() + "-" + ('0' + (today.getMonth() + 1)).slice(-2),
        });
        this.props.dispatch({
            type: "GetCourseInfo_Saga",
            onSuccess: this.onSuccessGetCourse,
            onFailure: this.onFailure,
        });
        if(!force && this.props.location && this.props.location.state && this.props.location.state.referrer){
            this.setState({ subjectList: this.props.beforeSubjectList });
            setTimeout(() => {
                this.refScroll.current.scrollTo(this.state.initScroll);
                this.setState({initScroll: 0});
            },33);
        } else {
            this.loadSubjectList(this.state.currentDate, this.state.subjectKbn);
        }
    }

    onSuccessGetSubjectList = (list) => {
        this.props.dispatch({
            type: "LoadEnd"
        });
        let subjectList = this.getSortedList(list);
        this.props.dispatch({
            type: "SaveSubjectList",
            subjectList: subjectList
        });
        this.props.dispatch({
            type: "GetCommentList_Saga",
            id: this.props.user.id,
            onSuccess: this.onSuccessGetCommentList,
            onFailure: this.onFailure,
        });
        this.setState({ subjectList: subjectList });
        setTimeout(() => {
            this.refScroll.current.scrollTo(this.state.initScroll);
            this.setState({initScroll: 0});
        },33);
    }

    onSuccessGetCommentList = (list) => {
        //feedbackDateの降順にソート
        list.sort((a,b)=>{
            return (new Date(a.feedbackDate) < new Date(b.feedbackDate) ? 1 : -1);
        })
        this.setState({ commentList: list });
    }
    onSuccessGetCourse = (course) => {
        const sendMax = course[this.props.user.course].sendMax;
        this.props.dispatch({
            type: "SetSendMax",
            sendMax: sendMax
        });
    }
    onFailure = (status, error) => {
        this.props.dispatch({
            type: "LoadEnd"
        });
    }

    loadSubjectList = (date, subjectKbn) => {
        let today = new Date();
        let recessStartDate = new Date(this.props.user.recessStartDate);
        let recessEndDate = new Date(this.props.user.recessEndDate);
        let targetDate = date
        targetDate.setHours(0);
        targetDate.setMinutes(0);
        targetDate.setSeconds(0);
        targetDate.setMilliseconds(0);
        if(this.props.user.recessStartDate !== '-' && this.props.user.recessEndDate !== '-') {
            recessStartDate.setHours(0);
            recessStartDate.setMinutes(0);
            recessStartDate.setMilliseconds(0);
            recessStartDate.setSeconds(0);
            recessEndDate.setHours(0);
            recessEndDate.setMinutes(0);
            recessEndDate.setMilliseconds(0);   
            recessEndDate.setSeconds(0);
        }
        if(this.props.user.recessStartDate !== '-' && this.props.user.recessEndDate !== '-' && 
            (recessStartDate <= targetDate && recessEndDate >= targetDate)) {

        } else {
            this.props.dispatch({
                type: "LoadStart"
            });
            const pDate = date.getFullYear() + "-" + ('0'+(date.getMonth() + 1)).slice(-2) + "-" + date.getDate();
            this.props.dispatch({
                type: "GetSubjectList_Saga",
                date: pDate,
                admin: false,
                subjectKbn: subjectKbn,
                onSuccess: this.onSuccessGetSubjectList,
                onFailure: this.onFailure,
            });
        }
    }

    onClickBackHome = () => {
        this.props.history.replace('/home');
    }

    onClickHelp = () => {
        this.setState({ helpDisplay: true });
    }

    closeHelp = () => {
        this.setState({ helpDisplay: false });
    }

    onClickSubject(e, subject) {
        this.props.dispatch({
            type: "TopPageScroll",
            scroll: this.refScroll.current.getScrollPos(),
        });
        this.props.dispatch({
            type: "LoadSubject",
            subject: subject,
        });
        this.props.dispatch({
            type: "TopPageDate",
            date: this.state.currentDate,
        });
        this.props.history.push('/training');
    }
    checkSubjectLoaded = () => {
        if (!this.loadingSubject && !this.loadingVocabulary && !this.loadingChunk && !this.loadingRecordHistory) {
            this.props.dispatch({
                type: "LoadEnd"
            });
            this.props.history.push('/training');
        }
    }
    getSortedList(list) {
        list.sort((a, b) => {
            if (a.order < b.order) return -1;
            if (a.order > b.order) return 1;
            return 0;
        });
        let order = 0;
        for (let key in list) {
            list[key].order = order;
            order++;
        }
        return list;
    }

    onClickFeedbackTitle = () => {
        localStorage.setItem('FeedBackDisplay', !this.state.feedbackContentsDisplay);
        this.setState({ 
            feedbackContentsDisplay: !this.state.feedbackContentsDisplay,
        });
    }

    onClickComment(e, index) {
        this.commentContents = [];
        // feedbackDateの年月部取得
        let feedbackDate = [""];
        if(this.state.commentList[index].feedbackDate){
            feedbackDate = this.state.commentList[index].feedbackDate.split(" ")
        }

        let title = feedbackDate[0] + "のフィードバック";
        this.setState({ 
            displayCommentDlg: true, 
            comment: {
                title: title,
                comment: this.state.commentList[index].comment,
            }
        });
    }

    onClickFavSubject(e, subject) {
        e.stopPropagation();

        // 顧客要望により、お気に入り登録・解除時はサーバー返却を待たない方式とする
        // 同一教材を連続タップすると、サーバー通信が稀に逆転する懸念がある
        // 懸念点については、顧客同意済み
        this.props.dispatch({
            type: 'SetFavSubject_Saga',
            subjectId: subject.id,
            favFlg: !subject.userStatus.favFlg,
        });
        subject.userStatus.favFlg = !subject.userStatus.favFlg;
        this.setState({ selectedSubject: subject });
    }

    onClickDelivery = () => {
        this.setState({ subjectKbn: SUBJECT_KBN.DELIVERY });
        localStorage.setItem('SubjectKbn', SUBJECT_KBN.DELIVERY);
        this.loadSubjectList(this.state.currentDate, SUBJECT_KBN.DELIVERY);
    }

    onClickStock = () => {
        this.setState({ subjectKbn: SUBJECT_KBN.STOCK });
        localStorage.setItem('SubjectKbn', SUBJECT_KBN.STOCK);
        this.loadSubjectList(this.state.currentDate, SUBJECT_KBN.STOCK);
    }

    onChangeSubjectDisplayType = (e) => {
        this.setState({ subjectDisplayType: e.target.dataset.value });
        localStorage.setItem('SubjectDisplayType', e.target.dataset.value);
    }

    createContents() {
        const today = new Date();

        let comment = [];
        for (let key in this.state.commentList) {
            const findSubject = (subject) => {
                return subject.id === this.state.commentList[key].subjectID;
            }
            let subject = this.state.subjectList.find(findSubject);
            if(subject) {
                let currentDate = this.state.currentDate.getFullYear() + "-" + ("0" + (this.state.currentDate.getMonth() + 1)).slice(-2);
                if(subject.subjectKbn === Number(SUBJECT_KBN.STOCK) ||
                    (subject.subjectKbn === Number(SUBJECT_KBN.DELIVERY) && subject.deliveryMonth === currentDate)) {
                    // feedbackDateの年月部取得
                    let feedbackDate = [""];
                    if(this.state.commentList[key].feedbackDate){
                        feedbackDate = this.state.commentList[key].feedbackDate.split(" ")
                    }
                    comment.push(
                        <Button key={key} onClick={e => this.onClickComment(e, key)}>
                            <FeedbackTitle>{this.state.commentList[key].subjectTitle}</FeedbackTitle>
                            <FeedbackDate>{feedbackDate[0] + " 受信"}</FeedbackDate>
                        </Button>
                    );
                } else {

                }
            } else {

            }
        }

        let subjects = [];
        let activateDate = new Date(this.props.user.activateDate);
        let unsubscribeDate = new Date(this.props.user.unsubscribeDate);
        
        // ユーザ登録前もしくは退会済
        if (activateDate > today || (this.props.user.unsubscribeDate !== "-" && unsubscribeDate < today)) {
            subjects.push(
                <Message key="nothing">
                    教材配信まで今しばらくお待ちください。
                </Message>
            );
        } else {
            let deliveryDate;
            let deliverySubjectExists = false;

            // 配信教材の場合、対象の年月の教材を抽出
            if (this.state.subjectKbn === SUBJECT_KBN.DELIVERY) {
                for (let key in this.state.subjectList) {
                    const subject = this.state.subjectList[key];
                    let split = subject.deliveryTime.split(':');
                    deliveryDate = new Date(convISO8601(subject.deliveryMonth + "-" + subject.deliveryDate + " " + ('0' + split[0]).slice(-2) + ":" + split[1]));
                    if (this.state.currentDate.getYear() === deliveryDate.getYear() &&
                        this.state.currentDate.getMonth() === deliveryDate.getMonth()
                    ) {
                        if (this.props.user.type === USERTYPE.TRAINER ||
                            this.props.user.type === USERTYPE.ADMIN ||
                            (activateDate <= deliveryDate && today >= deliveryDate)) {
                            deliverySubjectExists = true;
                            if (this.state.subjectDisplayType === SUBJECT_DISPLAY_TYPE.ALL ||
                                (this.state.subjectDisplayType === SUBJECT_DISPLAY_TYPE.FAVORITE && subject.userStatus.favFlg)) {
                                const props = {
                                    subject: subject,
                                    subjectKbn: this.state.subjectKbn,
                                    onClick: (e) => this.onClickSubject(e, subject),
                                    onClickFavSubject: (e) => this.onClickFavSubject(e, subject),
                                }
                                subjects.push(
                                    <Subject key={key} {...props}></Subject>
                                )
                            }
                        }
                    }
                }
            // ストック教材
            } else {
                for (let key in this.state.subjectList) {
                    const subject = this.state.subjectList[key];
                    let split = subject.deliveryTime.split(':');
                    deliveryDate = new Date(convISO8601(subject.deliveryMonth + "-" + subject.deliveryDate + " " + ('0' + split[0]).slice(-2) + ":" + split[1]));
                    // トレーナー、管理者でアプリログイン時は全て表示
                    // 利用開始日(activateDate)が当日以前の時は教材表示(利用開始日を迎えていない場合は教材非表示)
                    // 利用開始日(activateDate)より過去に配信した教材は表示する(配信日が未来日の教材は非表示)
                    if (this.props.user.type === USERTYPE.TRAINER ||
                        this.props.user.type === USERTYPE.ADMIN ||
                        (activateDate <= today && deliveryDate <= today)) {
                        deliverySubjectExists = true;
                        if (this.state.subjectDisplayType === SUBJECT_DISPLAY_TYPE.ALL ||
                            (this.state.subjectDisplayType === SUBJECT_DISPLAY_TYPE.FAVORITE && subject.userStatus.favFlg)) {
                            const props = {
                                subject: subject,
                                subjectKbn: this.state.subjectKbn,
                                onClick: (e) => this.onClickSubject(e, subject),
                                onClickFavSubject: (e) => this.onClickFavSubject(e, subject),
                            }
                            subjects.push(
                                <Subject key={key} {...props}></Subject>
                            )
                        }
                    }
                }
            }

            if (Object.keys(subjects).length === 0) {
                if (deliverySubjectExists) {
                    subjects.push(
                        <Message key="nothing">
                            お気に入りの教材はありません。 
                        </Message>
                    );
                } else {
                    subjects.push(
                        <Message key="nothing">
                            教材配信まで今しばらくお待ちください。
                        </Message>
                    );
                }
            }
        }

        return (
            <Contents>
                <Feedback>
                    <FeedbackHeader>
                        <FeedBackLeft />
                        シャドーイングのフィードバック
                        <FeedBackRight>
                            {comment.length === 0 ? null : <i className={this.state.feedbackContentsDisplay ? "fas fa-chevron-up" : "fas fa-chevron-down"} onClick={this.onClickFeedbackTitle} />}
                        </FeedBackRight>
                    </FeedbackHeader>
                    {this.state.feedbackContentsDisplay ? comment : null}
                </Feedback>
                <Subjects>
                    <SubjectTitles>
                        <RadioKinds Select={this.state.subjectKbn === SUBJECT_KBN.DELIVERY}  onClick={this.onClickDelivery}>配信教材</RadioKinds>
                        <RadioKinds Select={this.state.subjectKbn === SUBJECT_KBN.STOCK}  onClick={this.onClickStock}>ストック教材</RadioKinds>
                    </SubjectTitles>

                    <Controls>
                        <ControlsChild>
                            <Group>
                                <Radio Select={this.state.subjectDisplayType === SUBJECT_DISPLAY_TYPE.ALL} data-value={SUBJECT_DISPLAY_TYPE.ALL} onClick={this.onChangeSubjectDisplayType}>全て</Radio>
                                <Radio Select={this.state.subjectDisplayType === SUBJECT_DISPLAY_TYPE.FAVORITE} data-value={SUBJECT_DISPLAY_TYPE.FAVORITE} onClick={this.onChangeSubjectDisplayType}>お気に入り</Radio>
                            </Group>
                        </ControlsChild>
                    </Controls>
                    {subjects}
                </Subjects>
            </Contents>
        );
    }

    onClickCommentCnf = () => {
        this.setState({ displayCommentDlg: false });
    }
    createCommentDlgProps() {
        let commentContents = (
            <DialogMessage key="comment" Title={this.state.comment.title} Message={getSplitedDivs(this.state.comment.comment, '\n')} Align="left" />
        );
        return {
            display: this.state.displayCommentDlg,
            contents: commentContents,
            controls: {
                'OK': {
                    Color: '#000',
                    onClick: this.onClickCommentCnf,
                },
            }
        }
    }

    onClickDateBar = (e) => {
        let x = e.clientX - e.currentTarget.getBoundingClientRect().x;
        let width = e.currentTarget.getBoundingClientRect().width;
        let date = this.state.currentDate;
        if (x > (width / 2)) {
            date = getNextMonth(date);

            this.setState({ currentDate: date });
            this.loadSubjectList(date, this.state.subjectKbn);
        } else {
            date = getPrevMonth(date);

            this.setState({ currentDate: date });
            this.loadSubjectList(date, this.state.subjectKbn);
        }
        this.props.dispatch({
            type: "TopPageDate",
            date: date,
        });
    }

    onClickNextMonth = (e) => {
        let date = this.state.currentDate;
        date = getNextMonth(date);

        this.setState({ currentDate: date });
    }
    onClickPrevMonth = (e) => {
        let date = this.state.currentDate;

        let today = new Date();
        if (today.getFullYear() - 2 >= date.getFullYear()) {
            if (today.getMonth() === date.getMonth()) {
                return;
            }
        }

        date = getPrevMonth(date);
        this.setState({ currentDate: date });
    }

    getDisplayDate() {
        let displayDate = this.state.currentDate;
        return displayDate.getFullYear() + '年' + (displayDate.getMonth() + 1) + '月配信教材';
    }

    render() {
        const propsHeader = {
            current: this.state.current,
            onClickBackHome: this.onClickBackHome,
            onClickHelp: this.onClickHelp,
        };
        const propsScroll = {
            ref :this.refScroll,
            width: '100%',
            height: '100%',
            contents: this.createContents()
        };
        const propsContentsWrap = {
            Width: window.parent.screen.width + "px",
            Height: (this.state.subjectKbn === SUBJECT_KBN.DELIVERY) ? (window.innerHeight  - 64 - 51) + "px" : (window.innerHeight  - 64) + "px",
        };
        const propsFooter = {
            Display: this.state.subjectKbn === SUBJECT_KBN.DELIVERY,
            onClick: this.onClickDateBar,
        };
        const date = this.getDisplayDate();
        const propsHelp = {
            display: this.state.helpDisplay,
            closeHelp: this.closeHelp,
            page: 0,
        };
        const propsCommentDlg = this.createCommentDlgProps();

        return (
            <Body>
                <HeaderTop {...propsHeader}></HeaderTop>
                <ContentsWrap {...propsContentsWrap}>
                    <ScrollView {...propsScroll} />
                </ContentsWrap>
                <Footer {...propsFooter}>
                    <FooterCtrl>
                        <i className="fas fa-chevron-left" />
                    </FooterCtrl>
                    <div>
                        {date}
                    </div>
                    <FooterCtrl>
                        <i className="fas fa-chevron-right" />
                    </FooterCtrl>
                </Footer>
                <HelpDialog {...propsHelp} />
                <ModalDialog {...propsCommentDlg} />
                <LoadingView Display={this.props.loading} />
            </Body>
        );
    }
}

const mapStateToProps = store => {
    return {
        user: store.login.user,
        loading: store.loading.loading,
        afterLoadMessage: store.loading.message,
        loadResult: store.loading.state,
        toppageDate: store.setting.toppage,
        toppageScroll: store.setting.toppageScroll,
        beforeSubjectList: store.top.subjectList,
    }
};

const connectedTop = connect(mapStateToProps)(Top);
export { connectedTop as Top };

const Body = styled.div`
`;
const ContentsWrap = styled.div`
    width: ${props => (props.Width)};
    height: ${props => (props.Height)};
    background-color: #fbfbfb;
`;
const Contents = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding: 10px;
`;

const Feedback = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 10px;
    border-bottom: 1px solid #ccc;
    width: 100%;
    font-size: 14px;
`;

const FeedbackHeader = styled.div`
    display: flex;
    margin-bottom: 10px;
    width: 100%;
    font-size: 14px;
    justify-content: space-between;
    align-items: center;
    position: relative;
`;

const FeedBackLeft = styled.div`
    margin: 0 10px;
    color: #0077FF;
    width : 20px;
`;

const FeedBackRight = styled.div`
    margin: 0 10px;
    color: #0077FF;
    font-size: 20px;
`;

const Subjects = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    font-size: 14px;
`;

const SubjectTitles = styled.div`
    width: 100%;
    max-width: 300px;
    display: flex;
    align-items: center;
    border: 1px solid #888;

`;

const Controls = styled.div`
    width: 100%;
    max-width: 300px;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

const ControlsChild = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin:0px 20px 0px auto
`;

const Group = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 5px 0px;
    div {
        border: 1px solid #888;
    }
    div:first-of-type {
        border-radius: 5px 0 0 5px;
        border-left: 1px solid #888;
    }
    div:nth-of-type(even) {
        border-left: none;
        border-right: none;
    }
    div:last-of-type {
        border-radius: 0 5px 5px 0;
        border-right: 1px solid #888;
    }
`;

const RadioKinds = styled.div`
    color: ${props => props.Select ? "#fff" : "#888"};
    background-color: ${props => props.Select ? "#888" : "#fff"};
    padding: 2px 5px;
    cursor: pointer;
    width: 50%;
    text-align: center;
    font-size: 16px;
`;

const Radio = styled.div`
    color: ${props => props.Select ? "#fff" : "#888"};
    background-color: ${props => props.Select ? "#888" : "#fff"};
    padding: 2px 5px;
    cursor: pointer;
`;

const Message = styled.div`
    border: 1px solid #ccc;
    padding: 10px 0;
    background-color: #fff;
    width: 100%;
    text-align: center;
`;

const Button = styled.div`
    width: 90%;
    padding: 5px 10px;
    margin: 5px;
    background-color: #fff;
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
    position: relative;
    i {
        position: absolute;
        top: 20%;
        right: 5px;
        transform: translateY(-30%);
    }
`;

const Footer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 18px;
    padding: 5px 10px;
    display: ${props => props.Display ? "" : "none"};
`;
const FooterCtrl = styled.div`
    color: #00b050;
    padding: 0 5px;
    font-size: 24px;
`;
const FeedbackTitle = styled.div`
    font-size: 14px;
    font-weight: bold;
    margin: 0px 0px 3px;
`;
const FeedbackDate = styled.div`
    font-size: 12px;
`;
